<template>
    <div>
        <template v-if="feature[property.attribute].media.isPhoto && feature[property.attribute].media.photo">
            <image-viewer v-if="feature[property.attribute].media.photo.src != null" :src="feature[property.attribute].media.photo.src">
                Foto openen
            </image-viewer>
            <span v-else>{{ $t('photoNotAvailable') }}</span>
        </template>
        <template v-else-if="feature[property.attribute].media.link">
            <a :href="feature[property.attribute].media.link.href" :target="feature[property.attribute].media.link.extern ? '_blank' : '_self'">
                <template v-if="feature[property.attribute].media.link.src">
                    Foto openen
                </template>
                <template v-else>
                    {{feature[property.attribute].displayValue}}
                </template>
            </a>
        </template>
        <template v-else-if="feature[property.attribute].hyperlink && !feature[property.attribute].hyperlinkImage">
            <a :href="feature[property.attribute].displayValue" :target="feature[property.attribute].openExtern ? '_blank' : '_self'">
                <template v-if="feature[property.attribute].hyperlinkText">
                    {{feature[property.attribute].hyperlinkText}}
                </template>
                <template v-else-if="feature[property.attribute].value">
                    {{feature[property.attribute].value}}
                </template>
                <template v-else>
                    {{feature[property.attribute].displayValue}}
                </template>
            </a>
        </template>
        <template v-else-if="feature[property.attribute].hyperlink && feature[property.attribute].hyperlinkImage">
            <a :href="feature[property.attribute].displayValue" :target="feature[property.attribute].openExtern ? '_blank' : '_self'">
                <img class="detailimage"
                        :src="feature[property.attribute].displayValue"
                        alt="hyperlink"
                />
            </a>
        </template>
        <span v-else>{{ feature[property.attribute].displayValue }}</span>
    </div>
</template>

<script>
    import ImageViewer from '../../../BaseComponents/ImageViewer';
    export default {
        components: { 'image-viewer': ImageViewer, },
        props: {
            feature: { type: Object, required: true },
            property: { type: Object, required: true },
        }
    };
</script>

